import bankIcon from "../../../../../assets/images/Propxicon/bank.svg";
import bankNoteIcon from "../../../../../assets/images/Propxicon/bank-note-01.svg";
import creditCardIcon from "../../../../../assets/images/Propxicon/credit-card-01.svg";
import pencilLineIcon from "../../../../../assets/images/Propxicon/pencil-line.svg";

export const PaymentMethodsData = {
  BankTransfer: {
    id: 20695,
    key: "BankTransfer",
    title: "Bank-transfer",
    icon: bankIcon,
    event: "Leasing_journey_Payment_Details_Bank_Transfer_Option_Clicked",
  },
  Cash: {
    id: 20693,
    key: "Cash",
    title: "Cash",
    icon: bankNoteIcon,
    event: "Leasing_journey_Payment_Details_Cash_Option_Clicked",
  },
  Cheque: {
    id: 20694,
    key: "Cheque",
    title: "Cheque",
    icon: pencilLineIcon,
    event: "Leasing_journey_Payment_Details_Cheque_Option_Clicked",
  },
  Creditcard: {
    id: 20696,
    key: "Creditcard",
    title: "Credit-card",
    icon: creditCardIcon,
    event: "Leasing_journey_Payment_Details_Credit_Card_Option_Clicked",
  },
};